export default {
  path: '/',
  name: 'notificationRoot',
  component: () => import('@/layouts/BaseLayout'),
  children: [
    {
      path: '/notification',
      name: 'notification',
      meta: { title: '通知中心', permission: [] },
      component: () => import('@/views/notification/index.vue'),
    },
  ],
}
